var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatlab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "matlab-original-a",
    gradientUnits: "userSpaceOnUse",
    x1: 16.803,
    y1: 16.631,
    x2: 15.013,
    y2: 22.411,
    gradientTransform: "matrix(4 0 0 -4 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#29d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "matlab-original-b",
    gradientUnits: "userSpaceOnUse",
    x1: 29.71,
    y1: 18.983,
    x2: 11.71,
    y2: 14.563,
    gradientTransform: "scale(4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#c33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#de5239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#f06e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#fa8042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fe8643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fa7f42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#ef6c3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#dc4c37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#cf3633"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 70.2l31.879-12.88a82.62 82.62 0 0110.883-11.8c2.636-1.399 7.597-.641 16.68-11.918 8.796-11 11.597-20.403 15.718-20.403 6.52 0 11.32 14.082 18.602 35.403A461.75 461.75 0 00120 96.48c-7.602-7.082-14.078-14.718-21.48-14.52-6.88.161-14.52 8.321-22.88 18.802C69 109.16 60.2 114.922 56.763 114.8c0 0-8.883-25.121-16.32-29.2a10.563 10.563 0 00-9.563.797L8 70.16zm0 0",
    fill: "#49d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2 16.078c-2.68 3.602-5.92 10.203-11.76 17.524-9.082 11.277-14 10.52-16.68 11.918a78.673 78.673 0 00-10.882 11.8l13.2 9.64C64.28 51.68 70.28 35.122 74.96 24.399a54.649 54.649 0 014.238-8.32zm0 0",
    fill: "url(#matlab-original-a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2 13.2c-8.72 0-14.68 45.921-46.88 71.562 9.04-1.48 16.88 20.957 20.48 30.039 16-2.723 28.802-33.32 41.72-32.84 7.402.277 13.878 7.437 21.48 14.52C102.64 60 94.52 13.198 83.2 13.198zm0 0",
    fill: "url(#matlab-original-b)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatlab);
export default __webpack_public_path__ + "static/media/matlab.cc6187cc6d9e41996c097a556239f440.svg";
export { ForwardRef as ReactComponent };